import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-payment-provider-simulator',
  templateUrl: './payment-provider-acquirer-simulator.component.html',
  styleUrls: ['./payment-provider-acquirer-simulator.component.css']
})
export class PaymentProviderAcquirerSimulatorComponent implements OnInit {

  private _successUrl = '';
  private _cancelUrl = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.route.queryParams.subscribe(params => {
      if (params['return_url']) {
        this._successUrl = params['return_url'];
      }
      if (params['cancel_url']) {
        this._successUrl = params['cancel_url'];
      }
    });
  }

  ngOnInit() {
  }

  onPaymentSuccess() {
    if (this._successUrl) {
      window.open(this._successUrl, '_self');
    }
  }

  onPaymentCancel() {
    if (this._cancelUrl) {
      window.open(this._cancelUrl, '_self');
    } else {
      window.open(this._successUrl, '_self');
    }
  }

}
